import { message } from 'antd';

import { call, put, takeEvery, all, fork, select, takeLatest } from 'redux-saga/effects'
import { fetchSkillsAPI } from '../../../services/users-service';

import {
    FETCH_SKILLS,
    FETCH_SKILLS_START,
    FETCH_SKILLS_SUCCESS,
    FETCH_SKILLS_ERROR,
} from "../../actions/common/skillsAction";

export function* getSkills() {
    try {
        yield put({ type: FETCH_SKILLS_START })
        const response = yield call(fetchSkillsAPI);
        if (response.success) {
            yield put({ type: FETCH_SKILLS_SUCCESS, skills: response.data })
            localStorage.setItem("skills", JSON.stringify(response.data));
        } else {
            yield put({ type: FETCH_SKILLS_ERROR, error: response.error })
            message.error('Failed to fetch skills!');
        }
    } catch (error) {
        yield put({ type: FETCH_SKILLS_ERROR, error })
        message.error('Failed to fetch skills!');
    }
}

function* skillsWatcher() {
    yield takeLatest(FETCH_SKILLS, getSkills)
}

export default function* rootSaga() {
    yield all([
        skillsWatcher(),
    ]);
}